var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "open_icon",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "transform-origin": "center center",
    transform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.109 0H10.9897C10.4984 0 10.1055 0.4 10.1055 0.884211C10.1055 1.36842 10.5055 1.76842 10.9897 1.76842H12.9686L7.10897 7.62807C6.76511 7.97193 6.76511 8.53333 7.10897 8.88421C7.27739 9.05263 7.50195 9.14386 7.73353 9.14386C7.97213 9.14386 8.20371 9.04561 8.35809 8.88421L14.2177 3.02456V5.00351C14.2177 5.49474 14.6177 5.88772 15.102 5.88772C15.5862 5.88772 15.9862 5.48772 15.9862 5.00351V0.884211C16.0002 0.4 15.6002 0 15.109 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1088 7.37544C14.6175 7.37544 14.2246 7.77544 14.2246 8.25965V12.4351C14.2246 13.4246 13.4246 14.2246 12.4351 14.2246H3.56491C2.57544 14.2246 1.77544 13.4246 1.77544 12.4351V3.56491C1.77544 2.57544 2.57544 1.77544 3.56491 1.77544H7.70526C8.19649 1.77544 8.58947 1.37544 8.58947 0.891228C8.58947 0.407018 8.19649 0 7.70526 0H3.56491C1.6 0 0 1.6 0 3.56491V12.4351C0 14.4 1.6 16 3.56491 16H12.4351C14.4 16 16 14.4 16 12.4351V8.25965C16 7.76842 15.6 7.37544 15.1088 7.37544Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/open_icon.18638bff759cf7d19a9d500bed2ae871.svg";
export { ForwardRef as ReactComponent };